import React from "react";
import Spinner from "../ui-components/Spinner";

const FixedLoader = () => {
  return (
    <div className="w-full h-full fixed top-0 left-0 bg-white">
      <Spinner styleType="white" />
    </div>
  );
};

export default FixedLoader;
